import { forceUpdate, h } from '@stencil/core';
import debounce from 'lodash/debounce';
import Swiper from 'swiper';
import { DEBOUNCED_HANDLER_DELAY } from '@pes-ui/utils';
import CarouselButton from './CarouselButton';
import { isBrowser } from '../../../../globals/utils';
const SLIDES_TO_SHOW = 6;
const SLIDER_DEFAULT_OPTIONS = {
  slidesPerView: SLIDES_TO_SHOW,
  slidesPerGroup: SLIDES_TO_SHOW,
  centerInsufficientSlides: true,
  simulateTouch: false,
  initialSlide: 0,
  spaceBetween: 0,
  speed: 500,
};
export class BusinessLinesCarousel {
  constructor() {
    this.handleResize = () => {
      forceUpdate(this.host);
    };
    this.debouncedHandleResize = debounce(this.handleResize, DEBOUNCED_HANDLER_DELAY);
    this.setArrowDisabledState = () => {
      var _a, _b;
      if ((_a = this.sliderInstance) === null || _a === void 0 ? void 0 : _a.isBeginning) {
        this.disabledDirection = "prev";
        return;
      }
      if ((_b = this.sliderInstance) === null || _b === void 0 ? void 0 : _b.isEnd) {
        this.disabledDirection = "next";
        return;
      }
      this.disabledDirection = null;
    };
    this.createSliderContainerRef = (el) => {
      this.sliderContainerRef = el;
    };
    this.createSliderButtonClickHandler = (direction) => () => {
      var _a, _b;
      if (direction === "next") {
        (_a = this.sliderInstance) === null || _a === void 0 ? void 0 : _a.slideNext();
      }
      else {
        (_b = this.sliderInstance) === null || _b === void 0 ? void 0 : _b.slidePrev();
      }
    };
    this.showArrows = () => {
      var _a, _b;
      return !((_a = this.sliderInstance) === null || _a === void 0 ? void 0 : _a.isBeginning) || !((_b = this.sliderInstance) === null || _b === void 0 ? void 0 : _b.isEnd);
    };
    this.render = () => (h("div", { class: "business-lines-carousel" }, h("div", { class: "business-lines-carousel__container swiper-container", ref: this.createSliderContainerRef }, h("div", { class: "swiper-wrapper", style: { display: 'flex' } }, h("slot", null))), this.showArrows() && (h(CarouselButton, { direction: "prev", onClick: this.createSliderButtonClickHandler("prev"), disabled: this.disabledDirection === "prev" })), this.showArrows() && (h(CarouselButton, { direction: "next", onClick: this.createSliderButtonClickHandler("next"), disabled: this.disabledDirection === "next" }))));
    this.selectCell = undefined;
    this.disabledDirection = undefined;
  }
  selectCellDidChange(selectCell) {
    var _a;
    (_a = this.sliderInstance) === null || _a === void 0 ? void 0 : _a.slideTo(selectCell);
  }
  componentDidLoad() {
    if (!isBrowser()) {
      return null;
    }
    this.sliderCreate();
  }
  componentDidUpdate() {
    var _a;
    (_a = this.sliderInstance) === null || _a === void 0 ? void 0 : _a.update();
  }
  connectedCallback() {
    window.addEventListener('resize', this.debouncedHandleResize);
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this.debouncedHandleResize);
  }
  sliderCreate() {
    var _a, _b;
    this.sliderInstance = new Swiper(this.sliderContainerRef, SLIDER_DEFAULT_OPTIONS);
    (_a = this.sliderInstance) === null || _a === void 0 ? void 0 : _a.slideTo(this.selectCell);
    (_b = this.sliderInstance) === null || _b === void 0 ? void 0 : _b.on('slideChange', this.setArrowDisabledState);
    this.setArrowDisabledState();
  }
  static get is() { return "pes-business-lines-carousel"; }
  static get originalStyleUrls() {
    return {
      "$": ["business-lines-carousel.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["business-lines-carousel.css"]
    };
  }
  static get properties() {
    return {
      "selectCell": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "select-cell",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "disabledDirection": {}
    };
  }
  static get elementRef() { return "host"; }
  static get watchers() {
    return [{
        "propName": "selectCell",
        "methodName": "selectCellDidChange"
      }];
  }
}
